/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import React, { useState } from "react"; 
import axios from "../api/axiosInstance"; // O el import de axios que uses
import {
  draftGroupReservationsPath,
  draftGroupRoomDeletePath,
} from "../reservations/groupDraftUiContracts";

export default function ReservationTabsPanel({
  groupReservations,
  selectedReservationId,
  setSelectedReservationId,
  setActiveReservationId,
  setCustomerData,
  navigate,
  businessUnitId,
  formData,
  setFormData,
  reservationIdRef,
  reloadDatesFromDB,
  setDbDatesMap,
  reloadAdultsFromDB,
  setAdultsMap,
  reloadChildrenFromDB,
  setChildrenMap,
  reloadRoomCategoryIdFromDB,
  setRoomCategoryMap,
  reloadRoomCategoryDetailsFromDB,
  setRoomCategoryDetailsMap,
  reloadRoomIdFromDB,
  setRoomIdMap,
  reloadRoomRateIdFromDB,
  setRoomRateDetailsMap,
  permissions,
  hasAnyDates,
  hasAnyRoomRate,
  showCopyPanel,
  setShowCopyPanel,
  reloadGroupRateIdFromDB,
  setGroupRateIdMap,
  copyFrom,
  setCopyFrom,
  copyTo,
  setCopyTo,
  copyFromOptions,
  copyToOptions,
  handleCopyReservationInfo,
  setGroupReservations,
  hasAnyIncompleteReservation
  
  
}) {

  const [isCopying, setIsCopying] = useState(false);

  // LOGS DE SINCRONIZACIÓN
  console.log("🟢 groupReservations IDs (orden visual):", groupReservations.map(r => r.id));
  console.log("🟠 copyFromOptions:", copyFromOptions.map(opt => ({ id: opt.id })));
  console.log("🟣 copyToOptions:", copyToOptions.map(opt => ({ id: opt.id })));

  console.log("🔶 groupReservations RAW:", groupReservations);


  return (

<div className="d-flex justify-content-start flex-wrap gap-2 mb-3" style={{ padding: "0 0.5rem" }}>

      {/* 🔳 Pestaña de RESUMEN (siempre visible) */}
      <div className="position-relative d-inline-block me-2">
        <button
          className={`btn fw-bold px-3 py-1 rounded-pill ${
            selectedReservationId === "summary" ? "text-dark" : "text-light"
          }`}
          style={{
            fontSize: "0.8rem",
            background: selectedReservationId === "summary"
              ? "linear-gradient(135deg, #e0f7fa, #cfd8dc)" // activo: polar + platino
              : "linear-gradient(135deg, #37474f, #455a64)", // inactivo: azul oscuro elegante
            border: "1px solid #b0bec5",
            color: selectedReservationId === "summary" ? "#000" : "#fff"
          }}
          onClick={() => {
            setSelectedReservationId("summary");
          }}
        >
          Summary
        </button>
      </div>


  <>
    {(() => {
      console.log("🧩 [RENDER] Drawing tabs for reservations:", groupReservations.map(r => r.id));
      return null;
    })()}
    
  {groupReservations
    .filter((r) => r && r.id) // solo reservas válidas
    .sort((a, b) => a.group_index - b.group_index) // orden por group_index
    .map((res) => (
      <div key={res.id} className="position-relative d-inline-block">
        <button
          className={`btn fw-bold px-3 py-1 rounded-pill ${
            selectedReservationId === res.id ? "btn-warning text-dark" : "btn-outline-light"
          }`}
          style={{ fontSize: "0.8rem" }}
          onClick={async () => {
            const currentId = res.id;

            console.log("[Tabs][Click][FULL_DB_RELOAD]", currentId);

            reservationIdRef.current = currentId;
            setActiveReservationId(currentId);
            setSelectedReservationId(currentId);

            

            // 🔥 UNA sola fuente de verdad
            const { data } = await axios.get(
              `${process.env.REACT_APP_API_URL}/api/reservation-drafts/${currentId}`
            );

            // 🔥 Pintar TODO desde BD
            setFormData(data);
            
          }}



        >
          Room {res.group_index + 1}
        </button>

        {res.status === "Draft" && groupReservations.length > 1 && (
          <button
            className="btn btn-sm btn-danger position-absolute"
            style={{
              top: "-8px",
              right: "-8px",
              padding: "2px 6px",
              fontSize: "0.65rem",
              borderRadius: "50%",
              lineHeight: "1",
              zIndex: 10,
            }}
            title="Delete Room"
            onClick={async (e) => {
              e.stopPropagation();
              const confirmed = window.confirm("Are you sure you want to delete this room?");
              if (!confirmed) return;

              try {
                const groupId =
                  formData?.reservation_group_id ?? res?.reservation_group_id;
                const deletePath = draftGroupRoomDeletePath(groupId, res.id);
                const reloadPath = draftGroupReservationsPath(groupId);
                if (!deletePath || !reloadPath) {
                  throw new Error("The draft group or room identifier is invalid.");
                }

                await axios.delete(`${process.env.REACT_APP_API_URL}${deletePath}`);
                const groupRes = await axios.get(
                  `${process.env.REACT_APP_API_URL}${reloadPath}`
                );
                setGroupReservations(groupRes.data);
                console.log("📦 [setGroupReservations] (after delete) Group after deleting room:", groupRes.data);

                if (selectedReservationId === res.id && groupRes.data.length > 0) {
                  const first = groupRes.data[0];
                  setSelectedReservationId(first.id);
                  console.log("🎯 ACTIVE → selectedReservationId:", selectedReservationId, "| reservationIdRef:", reservationIdRef.current);
                  console.log("🎯 [setSelectedReservationId] Changed to first available:", first.id);
                  setActiveReservationId(first.id);
                  setSelectedReservationId(first.id);
                }
                

              } catch (error) {
                console.error("❌ Error deleting reservation:", error);
                alert(
                  error?.response?.data?.error ||
                    error?.response?.data?.message ||
                    error?.message ||
                    "Error deleting room."
                );
              }
            }}
          >
            ×
          </button>
        )}
      </div>
      
    ))}
    </>
    
    {groupReservations.length > 1 && hasAnyRoomRate && permissions["reservations.copy_info"] && (

      <div className="position-relative ms-auto me-2">

        <button
          className="btn btn-sm fw-bold btn-outline-light px-3 py-1"
        style={{ fontSize: "0.75rem", border: "1px solid #ffc107" }}
        onClick={() => setShowCopyPanel(prev => !prev)}
      >
        ⧉ Copy Info
      </button>

      {showCopyPanel && (
        <div
          className="bg-dark border border-warning text-light p-3 rounded shadow"
          style={{
            position: "absolute",
            top: "110%",
            right: 0,
            width: "270px",
            zIndex: 1000,
            fontSize: "0.75rem"
          }}
        >
          <div className="mb-2">
            <strong>Copy From:</strong>
            <select
              className="form-select form-select-sm mt-1"
              value={copyFrom}
              onChange={(e) => setCopyFrom(e.target.value)}
            >
              <option value="">Select Room</option>
              {copyFromOptions
                .map(option => {
                  const idx = groupReservations.findIndex(r => r.id === option.id);
                  if (idx < 0) return null;
                  return (
                    <option key={option.id} value={option.id}>
                      Room {idx + 1}
                    </option>
                  );
                })
              }



            </select>
          </div>

          <div className="mb-2">
            <strong>Copy To:</strong>
            <select
              className="form-select form-select-sm mt-1"
              value={copyTo}
              onChange={(e) => setCopyTo(e.target.value)}
            >
              <option value="">Select Room</option>
              {copyToOptions
                .map(option => {
                  const idx = groupReservations.findIndex(r => r.id === option.id);
                  // SOLO pinta si el ID está en groupReservations (idx >= 0)
                  if (idx < 0) return null;
                  return (
                    <option key={option.id} value={option.id}>
                      Room {idx + 1}
                    </option>
                  );
                })
              }
              {copyToOptions.filter(opt => groupReservations.some(r => r.id === opt.id)).length > 1 && (
                <option value="all">All</option>
              )}
            </select>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-sm btn-warning fw-bold"
              onClick={async () => {
                setIsCopying(true);
                await handleCopyReservationInfo();
                setIsCopying(false);
              }}
              disabled={!copyFrom || !copyTo || isCopying}
            >
              {isCopying ? "Copying..." : "Copy"}
            </button>


            <button
              className="btn btn-sm btn-secondary fw-bold"
              onClick={() => {
                setCopyFrom("");
                setCopyTo("");
                setShowCopyPanel(false);
              }}
            >
              Cancel
            </button>
          </div>


        </div>
      )}
    </div>
    )}
  </div>
   );
 }
